import { toggle } from "@gr-exports/async/toggle";
import { apm as agent } from "@elastic/apm-rum";
import type { OttoNexus } from "../../nexus/index.js";
import type { NexusHandler } from "../../nexus/function/function.types.js";

const TOGGLE_NAMESPACE = "apm_custom_error";

/**
 *
 *
 */
export type ApmDefaultLabels = {
  /**
 *
 *
 */
  team: string;
  /**
 *
 *
 */
  service: string;
  /**
 *
 *
 */
  module?: string;
};

/**
 *
 *
 *
 */
export type APMLabelsMap = Record<string, LabelValue>;

export interface CaptureErrorOptions {
  /**
 *
 *
 */
  type?: string;
  /**
 *
 *
 */
  custom?: APMLabelsMap;
}

/**
 *
 */
const isSendLogDisabledByToggle = (): boolean => !toggle.get(TOGGLE_NAMESPACE, true);

/**
 *
 */
const isNamespaceInvalid = (namespace: string | undefined): boolean =>
  typeof namespace !== "string" || namespace.length === 0;

/**
 *
 *
 *
 *
 */
const isNamespaceDisabledByToggle = (namespace: string): boolean =>
  !toggle.get(`${TOGGLE_NAMESPACE}_${namespace.replace(/-/g, "_")}`, true);

export const isDisabled = (namespace: string): boolean =>
  isNamespaceInvalid(namespace) ||
  isSendLogDisabledByToggle() ||
  isNamespaceDisabledByToggle(namespace);

/**
 *
 */
export const captureError = ((
  error,
  labels = {
    team: "unknown",
    service: "unknown",
  },
  options = {},
) => {
  /*                                                                       */
  /*                                         */
  if (!agent) return null;

  const type = options.type ?? error.name;

  /*                                                                   */
  if (isDisabled(type)) return null;

  /*                                                         */
  error.name = type;

  /*                                 */
  Object.assign(error, options.custom);

  /*                                  */
  labels.is_custom_captured = true;

  /*                                                         */
  if (!agent.getCurrentTransaction()) {
    agent.startTransaction("Capture Error", "custom.error", { managed: true });
  }

  /*                                                   */
  agent.captureError(error, { labels });
  return error;
}) satisfies NexusHandler<OttoNexus["apm"]["captureError"]>;
